import { redirect } from 'react-router-dom'

const ORDERED_DEFAULT_ONBOARDING_ROUTES = [
  // Phase 1: Initial motivation & exploration
  'dream-exploration',
  'dream-goals',
  'dream-why-deeper',

  // Phase 2: Current state assessment
  'vibe-today',
  'sleep-quality',
  'sleep-quality-feedback',
  'dream-memory',
  'dream-recall-stats',
  'dream-timing',

  // Phase 3: Past experience & obstacles
  'past-attempts',
  'dream-blocks',
  'blocks-feedback',

  // Phase 4: Dream personality
  'dreamer-type',
  'dream-flavor',
  'dream-themes',
  'emotional-state',

  // Phase 5: Self-awareness & mindfulness
  'mindful-moments',
  'grounding-in-real-life',

  // Phase 6: Future self visualization
  'ideal-dream-self',
  'self-belief',
  'transformation-feedback',

  // Phase 7: Commitment
  'commitment-level',
  'commitment-feedback',

  // Phase 8: Personalization preferences
  'dream-soundtrack',
  'dreamkeeper-avatar',
  'zodiac-sign',
  'dream-sharing',
  'dream-feedback',

  // Phase 9: Final personalization
  'inner-guide',
  'synced',
]

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()
  const currentPage = request.url.split('/').pop()?.split('?')[0]

  const next = getNext(request.url, ORDERED_DEFAULT_ONBOARDING_ROUTES)

  if (!next) return redirect('/sign-up/company')

  const nextPathname = getNextPathName({ next, url: request.url })

  if (currentPage === 'success') {
    const hash = formData.get('success') as string
    return redirect(`${nextPathname}#${hash}`)
  } else {
    return redirect(nextPathname)
  }
}

function getNext(url: string, routes: string[]): string | undefined {
  const pathname = new URL(url).pathname
  const current = pathname.split('/').pop()

  if (!current) return

  const currentIndex = routes.indexOf(current)
  const next = routes[currentIndex + 1]

  return next
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname
  const paths = currentPathname.split('/')
  const basePathname = paths.slice(0, -1).join('/')
  const nextPathname = basePathname + '/' + next
  return nextPathname
}
